import { render, staticRenderFns } from "./View10.vue?vue&type=template&id=cf75c4a0&scoped=true&"
import script from "./View10.vue?vue&type=script&lang=js&"
export * from "./View10.vue?vue&type=script&lang=js&"
import style0 from "./View10.vue?vue&type=style&index=0&id=cf75c4a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf75c4a0",
  null
  
)

export default component.exports